module.exports = __webpack_public_path__ + "img/d200712-1.43fd2897.jpg";